import { render, staticRenderFns } from "./TraxTrainingProgramEditTopBox.vue?vue&type=template&id=69d9e517"
import script from "./TraxTrainingProgramEditTopBox.vue?vue&type=script&lang=js"
export * from "./TraxTrainingProgramEditTopBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports